import { render } from "./VoteStatusWidget.vue?vue&type=template&id=2a3525b8"
import script from "./VoteStatusWidget.vue?vue&type=script&lang=js"
export * from "./VoteStatusWidget.vue?vue&type=script&lang=js"

import "./VoteStatusWidget.vue?vue&type=style&index=0&id=2a3525b8&lang=scss"
script.render = render

export default script